import { DomainInitPayload } from '@sxm-de/dev-kits/web-sdk/types';

interface ConvertDtokToMagicLinkFnPayload {
    token: string;
    countryCode: string;
}

export type ConvertDtokToMagicLinkFn = (
    payload: ConvertDtokToMagicLinkFnPayload,
) => Promise<string>;

export function initConvertDtokToMagicLinkFn({
    dependencies: { microservicesSdk },
}: DomainInitPayload): ConvertDtokToMagicLinkFn {
    return async ({ token, countryCode }: ConvertDtokToMagicLinkFnPayload) => {
        try {
            const dtokToMagicLinkResponse =
                countryCode.toLowerCase() === 'ca'
                    ? await microservicesSdk.domains.account.convertDtokToMagicLinkCanada(
                          {
                              token,
                          },
                      )
                    : await microservicesSdk.domains.account.convertDtokToMagicLink(
                          {
                              token,
                          },
                      );
            return dtokToMagicLinkResponse.magicLinkId;
        } catch (error: any) {
            /**
             * TODO:
             * Log error to error logger (not analytics).
             */
            throw new Error('SYSTEM');
        }
    };
}
